import React, { ReactNode } from "react";
import {
  FadeInUp as BaseFadeInUp,
  FadeIn as BaseFadeIn,
  SlideLeft as BaseSlideLeft,
  SlideRight as BaseSlideRight,
  ScaleUp,
} from "./ScrollAnimation";

// Legacy component wrappers for backwards compatibility
// These map old animation components to new ScrollAnimation components

export const FadeInFromBottom = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <BaseFadeInUp as="span" className="button-fade-in-bottom" threshold={0.4}>
      {children}
    </BaseFadeInUp>
  );
};

export const FadeInImage = ({ children }: { children: React.ReactNode }) => {
  return (
    <BaseFadeIn className="animation-wrapper" threshold={0.4} delay={500}>
      {children}
    </BaseFadeIn>
  );
};

export const FadeInFromLeft = ({ children }: { children: React.ReactNode }) => {
  return (
    <BaseSlideLeft className="animation-wrapper w-full h-full" threshold={0.4}>
      {children}
    </BaseSlideLeft>
  );
};

export const FadeInFromRight = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <BaseSlideRight className="animation-wrapper h-full w-full" threshold={0.4}>
      {children}
    </BaseSlideRight>
  );
};

export const FadeInWithPulse = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <ScaleUp
      as="span"
      className="animation-wrapper"
      threshold={0.5}
      duration={700}
    >
      {children}
    </ScaleUp>
  );
};
interface FadeAnimationsProp {
  children: React.ReactNode;
  animationType: "fade_from_left" | "fade_from_right";
}

export const FadeAnimations = ({
  children,
  animationType,
}: FadeAnimationsProp) => {
  switch (animationType) {
    case "fade_from_left":
      return <FadeInFromLeft>{children}</FadeInFromLeft>;
    case "fade_from_right":
      return <FadeInFromRight>{children}</FadeInFromRight>;
    default:
      return <FadeInFromLeft>{children}</FadeInFromLeft>;
  }
};

interface AnimatedContentProps {
  direction: string;
  children: ReactNode;
}

export const AnimatedContent = ({
  direction,
  children,
}: AnimatedContentProps) => {
  return direction === "is-row-reverse-desktop" ? (
    <FadeInFromRight>{children}</FadeInFromRight>
  ) : (
    <FadeInFromLeft>{children}</FadeInFromLeft>
  );
};
